import type React from 'react';

import { VideoOnIcon } from '@vlabs/icons';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Button } from '@vlabs/uikit/components/controls/button';
// ponytail: осознанный импорт роутов приложения — компонент используется только в point3
import { routes } from '@vlapps/point3/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { useStreamLiveTranslation } from '../i18n';
import type { StreamLiveProps } from '../types';

// ponytail: ведёт на стаб страницы трансляции — сама страница будет отдельной задачей (GUI-3863)
function StreamLiveButton({
  streamId,
  ...props
}: StreamLiveProps & ButtonProps): React.JSX.Element {
  const { t } = useStreamLiveTranslation();

  return (
    <Button
      as={Link}
      data-testid={`streamLiveButton-${streamId}`}
      icon={<VideoOnIcon />}
      kind="primary"
      to={generatePath(routes.sources.streamLive, { streamId })}
      variant="flat"
      {...props}
    >
      {t('title')}
    </Button>
  );
}

export { StreamLiveButton };
